import React, { useMemo } from 'react';
import cn from 'classnames';
import Hint from 'components/UI/Hint';
import { useTrans } from 'utils/localisation';
import { parseDesktopSummary } from '../../utils';
import { observer, pricingCalculator as store } from 'store';

import * as styles from './Summary.module.scss';

function Summary({ firstStep, currentStep, activeSection }) {
  const t = useTrans(['common', 'pricingCalculator']);
  const parsedSection = parseDesktopSummary(activeSection);
  const { getPayload } = store;
  const payload = getPayload();

  const specialistsAmount = useMemo(() => {
    if (payload['development-team']) {
      return Object.values(payload['development-team']).reduce((acc, value) => {
        acc += value;
        return acc;
      }, 0);
    }

    return null;
  }, [payload['development-team']]);

  const getTooltipContent = () => {
    if (payload['development-team']) {
      return (
        <div className={styles.tooltipContent}>
          {Object.entries(payload['development-team'])
            .map(([key, value]) => `${key} (${value})`)
            .join(', ')}
        </div>
      );
    }

    return '';
  };

  return (
    <div className={styles.summaryContainer}>
      <div className={styles.summary}>
        <div className={cn(styles.summaryContent, firstStep && styles.visible)}>
          {t('summaryPlaceholder')}
        </div>
        <div className={cn(styles.summaryContent, !firstStep && styles.visible)}>
          <div className={styles.title}>{t('summary')}</div>
          <div className={styles.summarySteps}>
            {parsedSection.map(({ summaryTitle, label }, i) => (
              <div
                key={i}
                className={cn(
                  styles.summaryStep,
                  currentStep >= i + 1 && styles.current,
                  currentStep > i + 1 && styles.withCheck,
                )}
              >
                <div className={styles.summaryStepTitle}>{summaryTitle}</div>
                {i === 0 && <div className={styles.summaryStepValue}>{label}</div>}
                {i !== 0 && Boolean(payload[label]) && typeof payload[label] === 'string' && (
                  <div key={payload[label]} className={styles.summaryStepValue}>
                    {label === 'duration' ? `${payload[label]} ${t('months')}` : payload[label]}
                  </div>
                )}
                {i !== 0 && Boolean(payload[label]) && label === 'development-team' && (
                  <div key={payload[label]} className={styles.summaryStepValue}>
                    {specialistsAmount === 1
                      ? `${specialistsAmount} ${t('person')}`
                      : `${specialistsAmount} ${t('persons')}`}

                    <Hint toggleOnHover withIcon content={getTooltipContent()} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(Summary);
